import { observer, pr, React, RouteComponentProps, theme, ui } from "aaa";
import profileStore from "stores/ProfileStore";
import { pushRoute } from "stores/RouterFunctions";
import { ISigningResponse } from "types/signing";
import { SigningComponent } from "../signing/views/SigningComponent";
import { CreditCardBusinessStore } from "./CreditCardBusinessStore";
import { ShopCreditCardBusinessRoutes } from "./ShopCreditCardBusinessRoutes";
import { PurchaseSummary } from "./ShopCreditCardBusinessSummary";

type IProps = RouteComponentProps<{}> & {
    store: CreditCardBusinessStore;
};

@observer
export class ShopCreditCardBusinessSigning extends React.Component<IProps, {}> {
    render() {
        return (
            <SigningComponent
                useWebVersion
                signingInfo={this.props.store.purchaseInfo ? this.props.store.purchaseInfo.signInfo : undefined}
                content={
                    <>
                        <div style={{ padding: theme.MARGIN }}>
                            <PurchaseSummary store={this.props.store} />
                        </div>
                        {!profileStore.isLoading &&
                            <>
                                <pr.LightSeparatorLine spacing={theme.MARGIN} />
                                <div style={{ padding: theme.MARGIN }}>
                                    <pr.SigningApproval>{ui.__("shop.creditCardBusiness.signing.acknowledge", { name: profileStore.name })}</pr.SigningApproval>
                                </div>
                            </>
                        }
                    </>

                }
                onSuccess={(response: ISigningResponse) => {
                    pushRoute(ShopCreditCardBusinessRoutes.SUCCESS);
                }}
                onRetry={async () => await this.props.store.purchaseCreditCard()}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/shopCreditCardBusiness/ShopCreditCardBusinessSigning.tsx